import Vue from 'vue';
import linkDynamic from '@editor/droplets/_bubble-options/components/link-dynamic';

export default Vue.component('edit-buy-button', {
  template: require('./template.html'),
  name: 'edit-buy-button',
  components: {
    linkDynamic,
  },
  props: ['droplet', 'show-edit-bubble', 'profile', 'product'],
  data() {
    return {
      display: {
        btnText: '',
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
  },
  methods: {
    setInitialValues() {
      this.display.btnText = this.droplet.btnText;
    },
    getInputVal(val) {
      return val.trim() !== '' ? val : false;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/buy-button/components/_edit-options/index.js